import { axiosMock } from '../client';
import { API_URL } from '@api/apiDictionary';
import { generateRandomUsersList } from '../../mocks/users';

export const fetchUsersListMock = async (name?: string) => {
  const data = generateRandomUsersList(50);

  axiosMock.onGet(API_URL.usersAffiliation).reply(200, data);
  axiosMock.onGet(API_URL.usersAffiliation, {
    params: { name },
  });
};
